import React, { ReactElement } from 'react';
import { Box, SvgIcon, SxProps, Typography } from '@mui/material';

interface InlineNoteProps {
  message: string | ReactElement;
  icon: React.ElementType;
  severity?: 'info' | 'warning' | 'error' | 'success';
  styles?: SxProps;
}

/*
 ** A Non-dismissable inline note that can be used to display extra information about a field or field state.
 ** To do: perhaps combine with existing InlineAlert component and roll into useInlineAlert
 */
const InlineNote: React.FC<InlineNoteProps> = ({
  message,
  icon,
  severity = 'info',
  styles,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: `${severity}.light`,
        py: 0.75,
        px: 2,
        mt: 1,
        display: 'flex',
        alignItems: 'flex-start',
        borderRadius: '4px',
        ...styles,
      }}
    >
      <SvgIcon
        component={icon}
        sx={{ color: `${severity}.dark`, my: 0.875, mr: 1.5 }}
      />
      <Typography sx={{ fontSize: '14px', py: 1 }}>{message}</Typography>
    </Box>
  );
};

export default InlineNote;
